import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ErrorHandler, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog, MatTab, MatTabGroup, MatRadioGroup, MatRadioButton } from '@angular/material';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import * as isString from 'lodash/isString';

import { SearchFormType } from '../models/search-form-type.model';
import { SearchQuery } from '../models/search-query.model';
import { AirportFilterListComponent } from '../airport-filter-list/airport-filter-list.component';
import { AirportService } from '../../airport/airport.service';
import { GoogleService } from '../../google/google.service';
import { mergeStates, State } from '../../shared/state-view/state.model';
import { environment } from '../../../environments/environment';
import { AutocompleteOverlayComponent } from '../../shared/autocomplete-overlay/autocomplete-overlay.component';
import { browser } from '../../../browser';
import {
  AutocompleteOption,
  AutocompleteOptionType,
  AutocompleteTriggerComponent,
  AutocompleteType
} from '../../shared/autocomplete-trigger/autocomplete-trigger.component';
import { Source } from '../../shared/models/source.model';
import { WhatsnewComponent } from '../../whatsnew/whatsnew.component';
import { WhatsNewService } from '../../shared/services/whats-new.service';
import { EventFilterListComponent } from '../event-filter-list/event-filter-list.component';
import { AviationEventFilter } from '../../shared/models/aviation-event-filter.model';
import { AviationEventFiltersService } from '../../shared/services/aviation-event-filters.service';
// tslint:disable-next-line:max-line-length
import { FlyingClubFinderFilterListComponent } from '../flying-club-finder-filter-list/flying-club-finder-filter-list.component';
import { FlyingClubFinderFilter } from '../../shared/models/flying-club-finder-filter.model';
import { FlyingClubFinderFiltersService } from '../../shared/services/flying-club-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FlightSchoolFinderFilterListComponent } from '../flight-school-finder-filter-list/flight-school-finder-filter-list.component';
import { FlightSchoolFinderFilter } from '../../shared/models/flight-school-finder-filter.model';
import { FlightSchoolFinderFiltersService } from '../../shared/services/flight-school-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { UniversityFinderFilterListComponent } from '../university-finder-filter-list/university-finder-filter-list.component';
import { UniversityFinderFilter } from '../../shared/models/university-finder-filter.model';
import { UniversityFinderFiltersService } from '../../shared/services/university-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FboFinderFilterListComponent } from '../fbo-finder-filter-list/fbo-finder-filter-list.component';
import { FboFinderFilter } from '../../shared/models/fbo-finder-filter.model';
import { FboFinderFiltersService } from '../../shared/services/fbo-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { ServiceRepairFinderFilterListComponent } from '../service-repair-finder-filter-list/service-repair-finder-filter-list.component';
import { ServiceRepairFinderFilter } from '../../shared/models/service-repair-finder-filter.model';
import { ServiceRepairFinderFiltersService } from '../../shared/services/service-repair-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { RentalSalesFinderFilterListComponent } from '../rental-sales-finder-filter-list/rental-sales-finder-filter-list.component';
import { RentalSalesFinderFilter } from '../../shared/models/rental-sales-finder-filter.model';
import { RentalSalesFinderFiltersService } from '../../shared/services/rental-sales-finder-filters.service';
import { Subscription } from 'rxjs';
import { LatLon } from '../../util/geodesy/latlon';
import { AuthService } from '../../auth/auth/auth.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { FuelFilterListComponent } from '../fuel-filter-list/fuel-filter-list.component';
import { FilterKeys } from '../filters/filters';
import { ShowDialogComponent } from '../../shared/show-dialog/show-dialog.component';



@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, AfterViewInit, OnDestroy {
  query: SearchQuery = new SearchQuery();
  form = new FormGroup ({
    wrapper: new FormGroup({
      type: new FormControl(),
      query: new FormControl(),
      usOrInternational: new FormControl()
    })
  });
  State = State;
  SearchFormType = SearchFormType;
  selectedTab: MatTab;
  numAirportFiltersSelected = 0;
  airportSearchState: State = State.Empty;
  locationState: State = State.Empty;
  videoOverlayActive = false;
  aviationEventFilter: AviationEventFilter;
  aviationEventFilterSubscription: Subscription;
  flyingClubFinderFilter: FlyingClubFinderFilter;
  flyingClubFinderFilterSubscription: Subscription;
  flightSchoolFinderFilter: FlightSchoolFinderFilter;
  flightSchoolFinderFilterSubscription: Subscription;
  universityFinderFilter: UniversityFinderFilter;
  universityFinderFilterSubscription: Subscription;
  fboFinderFilter: FboFinderFilter;
  fboFinderFilterSubscription: Subscription;
  serviceRepairFinderFilter: ServiceRepairFinderFilter;
  serviceRepairFinderFilterSubscription: Subscription;
  rentalSalesFinderFilter: RentalSalesFinderFilter;
  rentalSalesFinderFilterSubscription: Subscription;


  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild('airportsTab') airportsTab: MatTab;
  @ViewChild('activitiesTab') activitiesTab: MatTab;
  @ViewChild('aviationEventsTab') aviationEventsTab: MatTab;
  @ViewChild('flyingClubsTab') flyingClubsTab: MatTab;
  @ViewChild('flightSchoolsTab') flightSchoolsTab: MatTab;
  @ViewChild('universitiesTab') universitiesTab: MatTab;
  @ViewChild('fbosTab') fbosTab: MatTab;
  @ViewChild('serviceRepairsTab') serviceRepairsTab: MatTab;
  @ViewChild('rentalSalesTab') rentalSalesTab: MatTab;
  @ViewChild('fuelTab') fuelTab: MatTab;
  @ViewChild('airportFilters') airportFilters: AirportFilterListComponent;
  @ViewChild('aviationEventFilters') aviationEventFilters: EventFilterListComponent;
  @ViewChild('flyingClubFinderFilters') flyingClubFinderFilters: FlyingClubFinderFilterListComponent;
  @ViewChild('flightSchoolFinderFilters') flightSchoolFinderFilters: FlightSchoolFinderFilterListComponent;
  @ViewChild('universityFinderFilters') universityFinderFilters: UniversityFinderFilterListComponent;
  @ViewChild('fboFinderFilters') fboFinderFilters: FboFinderFilterListComponent;
  @ViewChild('serviceRepairFinderFilters') serviceRepairFinderFilters: ServiceRepairFinderFilterListComponent;
  @ViewChild('rentalSalesFinderFilters') rentalSalesFinderFilters: RentalSalesFinderFilterListComponent;
  @ViewChild('fuelFilters') fuelFilters: FuelFilterListComponent;
  @ViewChild('acTrigger', { read: AutocompleteTriggerComponent }) acTrigger: AutocompleteTriggerComponent;
  @ViewChild('queryField', { read: MatAutocompleteTrigger }) acInputTrigger: MatAutocompleteTrigger;
  @ViewChild('queryField', { read: ElementRef }) queryFieldEl: ElementRef;
  @ViewChild('acOverlay') acOverlay: AutocompleteOverlayComponent;

  constructor(
    private _router: Router,
    private _meta: Meta,
    private _title: Title,
    private _airportService: AirportService,
    private _google: GoogleService,
    private _errorHandler: ErrorHandler,
    private _cdref: ChangeDetectorRef,
    private _matDialog: MatDialog,
    private _whatsNewService: WhatsNewService,
    private _aviationEventFiltersService: AviationEventFiltersService,
    private _flyingClubFinderFiltersService: FlyingClubFinderFiltersService,
    private _flightSchoolFinderFiltersService: FlightSchoolFinderFiltersService,
    private _universityFinderFiltersService: UniversityFinderFiltersService,
    private _fboFinderFiltersService: FboFinderFiltersService,
    private _serviceRepairFinderFiltersService: ServiceRepairFinderFiltersService,
    private _rentalSalesFinderFiltersService: RentalSalesFinderFiltersService,
    private _route: ActivatedRoute,
    private _auth: AuthService,
    private _analyticsService: AnalyticsService
  ) {
    this._title.setTitle(environment.appName);
    this._meta.updateTag({
      name: 'description',
      content: 'AOPA Airports is an online database of thousands of public- and private-use airports. '
        + 'Airport listings include airport diagrams, fuel prices, and more.'
    });

    // This allows the jump to anchor tag to favorites from the airport details page.
    // Ugly.  Hopefully some day they will fix this: https://github.com/angular/angular/issues/6595
    _router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = _router.parseUrl(_router.url);
        if (tree.fragment) {
          const element = document.querySelector('#' + tree.fragment);
          if (element) { element.scrollIntoView(true); }
        }
      }
    });
  }

  get queryCtrl(): AbstractControl {
    return this.form.get('wrapper').get('query');
  }

  get queryLabel(): string {
    if (this.query.type === SearchFormType.Activities) {
      return 'Location';
    } else if (this.query.type === SearchFormType.AviationEvents) {
      if (this.isInternational) {
        return 'Location';
      } else {
        return 'Location (optional)';
      }
    } else if (this.query.type === SearchFormType.FlyingClubs) {
      return 'Location';
    } else if (this.query.type === SearchFormType.FlightSchools) {
      return 'Location';
    } else if (this.query.type === SearchFormType.Universities) {
      return 'Location (optional)';
    } else if (this.query.type === SearchFormType.Fbos) {
      return 'Location';
    } else if (this.query.type === SearchFormType.ServiceRepair) {
      return 'Location';
    } else if (this.query.type === SearchFormType.RentalSales) {
      return 'Location';
    } else {
      return 'Airport ID, Name, City, or State';
    }
  }

  get searchPlaceholder(): string {
    if (this.query.type === SearchFormType.Activities) {
      return 'Search by City Name';
    } else if (this.query.type === SearchFormType.AviationEvents) {
      if (this.isInternational) {
        return 'City or Country Name';
      } else {
        return 'Airport ID, Airport Name, State Name';
      }
    } else if (this.query.type === SearchFormType.FlyingClubs) {
      return 'Airport ID, ZIP, City, or State';
    } else if (this.query.type === SearchFormType.FlightSchools) {
      return 'Airport ID, ZIP, City, or State';
    } else if (this.query.type === SearchFormType.Universities) {
      return 'Airport ID, ZIP, City, or State';
    } else if (this.query.type === SearchFormType.Fbos) {
      return 'Airport ID, ZIP, City, or State';
    } else if (this.query.type === SearchFormType.ServiceRepair) {
      return 'Airport ID, ZIP, City, or State';
    } else if (this.query.type === SearchFormType.RentalSales) {
      return 'Airport ID, ZIP, City, or State';
    } else {
      return 'Search';
    }
  }

  get queryType(): AutocompleteType {
    return (this.query.type === SearchFormType.Activities)
      ? AutocompleteType.Google
      : AutocompleteType.Combined;
  }

  get valid(): boolean {
    return this.query.validate().valid;
  }

  get validationReason(): string {
    const result = this.query.validate();
    if (!result.valid) {
      if (this.query.type === SearchFormType.FlyingClubs || this.query.type === SearchFormType.FlightSchools
          || this.query.type === SearchFormType.Universities || this.query.type === SearchFormType.Fbos
          || this.query.type === SearchFormType.ServiceRepair || this.query.type === SearchFormType.RentalSales) {
        return 'Please enter an ICAO or FAA airport identifier, a 5-digit ZIP code, city, or state.';
      }
      return result.message || 'The query you entered is not valid.';
    }
    return null;
  }

  get searchState(): State {
    return mergeStates(this.airportSearchState, this.locationState);
  }

  get searchErrorMsg(): string {
    if (this.airportSearchState === State.Error) {
      return 'An error occurred searching for airports or locations. Please try again later.';
    }
    if (this.locationState === State.Error) {
      return 'An error occurred resolving the location latitude and longitude. Please try again later.';
    }
    return null;
  }

  get isInternational(): boolean {
    return this.form.get('wrapper').get('usOrInternational').value === 'International';
  }

  get currentSearchTab(): SearchFormType {
    return this.query.type;
  }

  ngOnInit() {
    this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(ae => {
      this.aviationEventFilter = ae;
    });
    this.flyingClubFinderFilterSubscription = this._flyingClubFinderFiltersService.flyingClubFinderFilter.subscribe(f => {
      this.flyingClubFinderFilter = f;
    });
    this.flightSchoolFinderFilterSubscription = this._flightSchoolFinderFiltersService.flightSchoolFinderFilter.subscribe(f => {
      this.flightSchoolFinderFilter = f;
    });
    this.universityFinderFilterSubscription = this._universityFinderFiltersService.universityFinderFilter.subscribe(f => {
      this.universityFinderFilter = f;
    });
    this.fboFinderFilterSubscription = this._fboFinderFiltersService.fboFinderFilter.subscribe(f => {
      this.fboFinderFilter = f;
    });
    this.serviceRepairFinderFilterSubscription = this._serviceRepairFinderFiltersService.serviceRepairFinderFilter.subscribe(f => {
      this.serviceRepairFinderFilter = f;
    });
    this.rentalSalesFinderFilterSubscription = this._rentalSalesFinderFiltersService.rentalSalesFinderFilter.subscribe(f => {
      this.rentalSalesFinderFilter = f;
    });
  }

  async ngAfterViewInit() {
    setTimeout(() => {
      // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer
      // interactions.
      this.onQueryBlur();

      // Store the initially selected tab.
      this.selectedTab = this._getSelectedTab();

      // Get the number of initially selected filters
      this.numAirportFiltersSelected = this.airportFilters.getNumSelected();

      setTimeout(() => {
        if (this._route.snapshot.queryParamMap.has('t')) {
          if (this._route.snapshot.queryParamMap.get('t') === 'activities') {
            this.query.type = SearchFormType.Activities;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'events') {
            this.query.type = SearchFormType.AviationEvents;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'flyingclubs') {
            this.query.type = SearchFormType.FlyingClubs;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'flightschools') {
            this.query.type = SearchFormType.FlightSchools;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'universities') {
            this.query.type = SearchFormType.Universities;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'fbos') {
            this.query.type = SearchFormType.Fbos;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'servicerepair') {
            this.query.type = SearchFormType.ServiceRepair;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'rentalsales') {
            this.query.type = SearchFormType.RentalSales;
          }
          if (this._route.snapshot.queryParamMap.get('t') === 'fuel') {
            this.query.type = SearchFormType.FuelPrice;
          }
        }
      }, 300);
    }, 100);

    const showWhatsNew = await this._whatsNewService.shouldShowWhatsNew();
    if (showWhatsNew) {
      const dialogRef = this._matDialog.open(WhatsnewComponent);
      dialogRef.afterClosed().subscribe(result => {
        this._whatsNewService.displayedWhatsNew();
      });
    }
    /* this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(ae => {
      this.aviationEventFilter = ae;
    }); */
    this._analyticsService.pageView('airport_landingpage', 'Airport/Event Landing Page');
    /* if (this._auth.authenticated && this._auth.endUser) {
      this._analyticsService.trackEvent('airport_landingpage_loggedin', this._auth.recid, this._auth.recid);
    } else {
      this._analyticsService.trackEvent('airport_landingpage_loggedout', '', '');
    } */
  }

  ngOnDestroy() {
    this.aviationEventFilterSubscription.unsubscribe();
    if (this.flyingClubFinderFilterSubscription) {
      this.flyingClubFinderFilterSubscription.unsubscribe();
    }
    if (this.flightSchoolFinderFilterSubscription) {
      this.flightSchoolFinderFilterSubscription.unsubscribe();
    }
    if (this.universityFinderFilterSubscription) {
      this.universityFinderFilterSubscription.unsubscribe();
    }
    if (this.fboFinderFilterSubscription) {
      this.fboFinderFilterSubscription.unsubscribe();
    }
    if (this.serviceRepairFinderFilterSubscription) {
      this.serviceRepairFinderFilterSubscription.unsubscribe();
    }
    if (this.rentalSalesFinderFilterSubscription) {
      this.rentalSalesFinderFilterSubscription.unsubscribe();
    }
  }

  changeQueryParams() {
    let queryType = SearchFormType.Airports;
    if (this.query.type === SearchFormType.AviationEvents) {
      queryType = SearchFormType.AviationEvents;
      if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
        this.fuelFilters.filterComponents.filter(c => c.filter.enabled).forEach(filt => {
          if (filt.filter.key !== FilterKeys.PublicUse) {
            filt.filter.enabled = false;
          }
        });
      }
    } else if (this.query.type === SearchFormType.Activities) {
      queryType = SearchFormType.Activities;
      if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
        this.fuelFilters.filterComponents.filter(c => c.filter.enabled).forEach(filt => {
          if (filt.filter.key !== FilterKeys.PublicUse) {
            filt.filter.enabled = false;
          }
        });
      }
    } else if (this.query.type === SearchFormType.FlyingClubs) {
      queryType = SearchFormType.FlyingClubs;
    } else if (this.query.type === SearchFormType.FlightSchools) {
      queryType = SearchFormType.FlightSchools;
    } else if (this.query.type === SearchFormType.Universities) {
      queryType = SearchFormType.Universities;
    } else if (this.query.type === SearchFormType.Fbos) {
      queryType = SearchFormType.Fbos;
    } else if (this.query.type === SearchFormType.ServiceRepair) {
      queryType = SearchFormType.ServiceRepair;
    } else if (this.query.type === SearchFormType.RentalSales) {
      queryType = SearchFormType.RentalSales;
    } else if (this.query.type === SearchFormType.FuelPrice) {
      queryType = SearchFormType.FuelPrice;
      if (this.airportFilters && this.airportFilters.fuel100LLFilter) {
        this.airportFilters.filterComponents.filter(c => c.filter.enabled).forEach(filt => {
          if (filt.filter.key !== FilterKeys.PublicUse) {
            filt.filter.enabled = false;
          }
        });
        // this.airportFilters.fuel100LLFilter.enabled = true;
      }
    } else {
      queryType = SearchFormType.Airports;
      if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
        this.fuelFilters.filterComponents.filter(c => c.filter.enabled).forEach(filt => {
          if (filt.filter.key !== FilterKeys.PublicUse) {
            filt.filter.enabled = false;
          }
        });
        /* this.fuelFilters.fuel100LLFilter.enabled = false;
        this.fuelFilters.fuelJetAFilter.enabled = false;
        this.fuelFilters.fuelMOGASFilter.enabled = false;
        this.fuelFilters.fuelUL94Filter.enabled = false; */
      }
    }

    const queryParams = { 't': queryType };

    this._router.navigate(
      [],
      {
        relativeTo: this._route,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onSelectTab(event) {
    this.selectedTab = event.tab;
  }

  private _getSelectedTab(): MatTab {
    if (!this.tabGroup._tabs) {
      return null;
    }
    return this.tabGroup._tabs
      .toArray()
      .find((tab: MatTab, i: number) => i === this.tabGroup.selectedIndex);
  }

  onSubmit() {
    if (this.query.type === SearchFormType.AviationEvents) {
      this.query.aviationEventsFilter = this.aviationEventFilter;
      this.query.radius = 500;
    }
    if (this.query.type === SearchFormType.FlyingClubs) {
      this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    if (this.query.type === SearchFormType.FlightSchools) {
      this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    if (this.query.type === SearchFormType.Universities) {
      this.query.universityFinderFilter = this.universityFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    if (this.query.type === SearchFormType.Fbos) {
      this.query.fboFinderFilter = this.fboFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    if (this.query.type === SearchFormType.ServiceRepair) {
      this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    if (this.query.type === SearchFormType.RentalSales) {
      this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
      this.query.radius = this.query.radius || 50;
    }
    this.acTrigger.submit(this.query);
  }

  onClickAdvancedSearch() {
    if (this.query.type === SearchFormType.AviationEvents) {
      this.query.aviationEventsFilter = this.aviationEventFilter;
      this.acTrigger.submit(this.query);
      // this._router.navigate(['/search'], { queryParams: {'t': 'events', 'public': 1} });
    } else {
      this._router.navigate(['/search'], { queryParams: {'public': 1} });
    }
  }

  onItemSelected (e: AutocompleteOption) {
    switch (e.type) {
      case AutocompleteOptionType.Airport:
        if (this.query.type === SearchFormType.AviationEvents) {
          this.query.term = e.airport.identifier;
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = 50;
          this.query.aviationEventsFilter = this.aviationEventFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.FlyingClubs) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.FlightSchools) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.Universities) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.universityFinderFilter = this.universityFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.Fbos) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.fboFinderFilter = this.fboFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.ServiceRepair) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.RentalSales) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = this.query.radius || 50;
          this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else if (this.query.type === SearchFormType.FuelPrice) {
          this.query.term = '';
          this.query.locationDescription = e.airport.identifier || '';
          this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
          this.query.radius = 50;
          const params = this.query.encode();
          this._router.navigate(['/search'], { queryParams: params });
        } else {
          if (e.airport.sourceId === Source.CaribbeanGuide || e.airport.sourceId === Source.BahamasGuide) {
            this._router.navigate(['/airports',  e.airport.identifier, 'island']);
          } else {
            this._router.navigate(['/airports', e.airport.identifier]);
          }
        }
        return;
      case AutocompleteOptionType.Location:
        this.queryFieldEl.nativeElement.value = e.location.description;
        this._resolveLocation(e.location.place_id, e.location.description);
        break;
      case AutocompleteOptionType.State:
        this.queryFieldEl.nativeElement.value = e.state.name;
        this.query.term = '';
        this.query.locationDescription = e.state.name;
        this.query.state = e.state.stateCode;
        break;
      case AutocompleteOptionType.ZipCode: {
        // A ZIP entry stays a finder search (Flying Clubs / Flight Schools): the API resolves the ZIP
        // centroid from the WebApps ZIPCodes table and runs a radius search. Keep query.type rather than
        // forcing Airports.
        this.query.term = e.query;
        this.query.location = null;
        this.query.bounds = null;
        this.query.state = null;
        this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
        this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
        this.query.universityFinderFilter = this.universityFinderFilter;
        this.query.fboFinderFilter = this.fboFinderFilter;
        this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
        this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
        const zipParams = this.query.encode();
        this._router.navigate(['/search'], { queryParams: zipParams });
        return;
      }
      default:
        this.query.type = SearchFormType.Airports;
        this.query.term = e.query;
        const params = this.query.encode();
        this._router.navigate(['/search'], { queryParams: params });
    }
  }

  onAirportFiltersChanged() {
    this.numAirportFiltersSelected = this.airportFilters.getNumSelected();
  }

  onFuelFiltersChanged() {
    this.numAirportFiltersSelected = this.fuelFilters.getNumSelected();
  }

  onQueryKeyPress() {
    setTimeout(() => {
      this.query.term = this.queryCtrl.value;
      if (this.queryCtrl && this.queryCtrl.value && this.queryCtrl.value.length < 1) {
        this.query.term = '';
      }
    }, 0);
  }

  onQueryFocus(e: Event) {
    if (browser && (browser.os === 'iOS' || browser.os === 'Android OS')) {
      // Angular Material's autocomplete component is not really usable on mobile:
      // https://github.com/angular/material2/issues/6341
      // Instead, pop up a full-screen overlay with a search box and a filtered list of suggestions
      e.preventDefault();
      this.acOverlay.show();
      this._cdref.detectChanges();
      this.acOverlay.focus();
    }
  }

  onQueryBlur() {
    // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer interactions.
    setTimeout(() => this.acInputTrigger.closePanel(), 300);
  }

  onQueryTypeChanged(event: any) {
    this.changeQueryParams();
    this.tabGroup.selectedIndex = 1;
  }

  enableForm() {
    this.setEnabledState(true);
  }

  disableForm() {
    this.setEnabledState(false);
  }

  setEnabledState(enabled: boolean) {
    this.wrapper.nativeElement.disabled = !enabled;
  }

  private async _resolveLocation(placeId: string, description: string) {
    this.locationState = State.Loading;
    this.disableForm();
    try {
      const location = await this._google.geocodePlace(placeId);
      this.query.term = '';
      this.query.location = location;
      this.query.locationDescription = description || '';
      this.query.radius = this.query.radius || 50;
      this.locationState = State.Content;
    } catch (e) {
      this._errorHandler.handleError(e);
      this.locationState = State.Error;
    } finally {
      this.enableForm();
    }
  }

  openVideoOverlay() {
    this.videoOverlayActive = true;
  }

  closeVideoOverlay() {
    this.videoOverlayActive = false;
  }
  addEventFormClick() {
    if (!this._auth.authenticated || !this._auth.endUser) {
      this._auth.redirectToLogin();
      return;
    }
    this._router.navigate(['/addevent']);
  }

  onClickFavorite(favoriteType: string) {
    // Switch tabs if trying to show favorites of a different tab type
    if (this.query.type !== SearchFormType.Airports && favoriteType === 'airports') {
      this.query.type = SearchFormType.Airports;
      this.changeQueryParams();
      // Delay to allow for switching tabs if tab switch required
      setTimeout(() => {
        const element = document.querySelector('#favorites');
        if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
      }, 400);
    } else if (this.query.type !== SearchFormType.AviationEvents && favoriteType === 'events') {
      this.query.type = SearchFormType.AviationEvents;
      this.changeQueryParams();
      // Delay to allow for switching tabs if tab switch required
      setTimeout(() => {
        const element = document.querySelector('#favorites');
        if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
      }, 400);
    } else {
      const element = document.querySelector('#favorites');
      if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
    }
  }

  clickUsorInternational(event: any) {
    if (event.value === 'International') {
      this.aviationEventFilter.international = true;
    } else {
      this.aviationEventFilter.international = false;
    }
    this.query.aviationEventsFilter = this.aviationEventFilter;
  }

  onClickFuelLearnMore() {
    const dialogRef = this._matDialog.open(ShowDialogComponent);
  }
}
